import React, { Component } from "react";
import SignUp from "../Buttons/SignUp";
import { addUTMToDictionary } from "../../libs/analytics";

import "whatwg-fetch";
import config from "../../data/config";

import loader from "../../images/loader.gif";

const apiURL = config.signupApiURL;

export default class MyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailActive: false,
      mobileActive: false,
      loader: false,
      errorMsg: null,
      CTA: props.CTA || "Get card reader",
      apiURL: props.apiURL || apiURL,
      track: props.track || null,
      version: props.version || ""
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  serialize(form) {
    let field,
      l,
      s = [];
    if (typeof form == "object" && form.nodeName == "FORM") {
      let len = form.elements.length;
      for (let i = 0; i < len; i++) {
        field = form.elements[i];
        if (
          field.name &&
          !field.disabled &&
          field.type != "file" &&
          field.type != "reset" &&
          field.type != "submit" &&
          field.type != "button"
        ) {
          if (field.type == "select-multiple") {
            l = form.elements[i].options.length;
            for (let j = 0; j < l; j++) {
              if (field.options[j].selected)
                s[s.length] =
                  encodeURIComponent(field.name) +
                  "=" +
                  encodeURIComponent(field.options[j].value);
            }
          } else if (
            (field.type != "checkbox" && field.type != "radio") ||
            field.checked
          ) {
            s[s.length] =
              encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(field.value);
          }
        }
      }
    }
    return s.join("&").replace(/%20/g, "+");
  }

  emailStateToggle() {
    this.setState({
      emailActive: !this.state.emailActive
    });
  }

  numberStateToggle() {
    this.setState({
      mobileActive: !this.state.mobileActive
    });
  }

  checkForRetail() {
    return this.props.retail ? "&signupFeature[]=retailSignup" : "";
  }

  checkForSessionPromo() {
    const promo = sessionStorage.getItem("promoCode");

    if (promo) {
      return "&promoCode=" + promo;
    }

    return "";
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({
      loader: true,
      errorMsg: null
    });

    let formParameters = this.serialize(event.target);

    const url = window.location.href;
    const oldQueryParams =
      url.indexOf("?") > -1 ? `&${url.split("?").pop()}` : "";
    const utmParameters = addUTMToDictionary({});
    let utmQueryString = Object.keys(utmParameters)
      .map(key => key + "=" + utmParameters[key])
      .join("&");
    if (utmQueryString !== "") {
      utmQueryString = "&" + utmQueryString;
    }

    const signupVersion = `&version=${this.state.version}`;

    const windowPromo = this.checkForSessionPromo();
    const retail = this.checkForRetail();

    const queryString =
      formParameters +
      oldQueryParams +
      utmQueryString +
      windowPromo +
      signupVersion +
      retail;
    console.log(queryString);

    fetch(`${this.state.apiURL}/api/start?${queryString}`, {
      method: "GET"
    })
      .then(response => response.json())
      .then(json => {
        if (json.status === 200) {
          window.analytics &&
            window.analytics.identify(json.data.signUp.userUUID);
          window.analytics &&
            window.analytics.track("[signup] sign-up started");

          if (this.state.track) {
            window.analytics && window.analytics.track(this.state.track);
          }

          setTimeout(
            () =>
              (window.location = `${this.state.apiURL}/continue/${
                json.data.signUp.uuid
              }`),
            500
          );
        } else {
          throw json;
        }
      })
      .catch(error => {
        console.log("uncaught exception occurred during poll", error);

        const msg = error.message
          ? error.message
          : "An error occurred while attempting to sign you up. If it continues, please contact support. Tel +27 87 550 9626";

        this.setState({
          errorMsg: msg,
          loader: false
        });
      });
  }

  checkError() {
    if (this.state.errorMsg != null) {
      return <div className="alert alert-danger">{this.state.errorMsg}</div>;
    }
    return null;
  }

  render() {
    return (
      <form className="signup-form" onSubmit={this.handleSubmit}>
        {this.checkError()}
        <div className="form-row form-group">
          <label className={this.state.emailActive ? "active" : ""}>
            Email
          </label>
          <input
            required
            onFocus={() => this.emailStateToggle()}
            onBlur={() => this.emailStateToggle()}
            type="email"
            name="email"
            className="form-control"
            id="inputEmail"
            placeholder="name@gmail.com"
          />
        </div>
        <div className="form-row form-group">
          <label className={this.state.mobileActive ? "active" : ""}>
            Mobile
          </label>
          <input
            required
            onFocus={() => this.numberStateToggle()}
            onBlur={() => this.numberStateToggle()}
            type="tel"
            name="mobileNumber"
            pattern="^[0-9-+s()]*$"
            className="form-control"
            id="inputEmail"
            maxLength="12"
            placeholder="082 555 5555"
          />
        </div>
        <div className="form-row form-group">
          <button className="btn btn-primary">
            {this.state.loader ? (
              <img src={loader} width={25} />
            ) : (
              this.state.CTA
            )}
          </button>
        </div>
        <div
          className="text-center"
          style={{ fontSize: "12px", lineHeight: 1.5 }}
        >
          <div>
            Already using Yoco? <a href="http://portal.yoco.co.za">Login</a>
          </div>
          <div>
            By continuing, I agree to Yoco's{" "}
            <a href="https://www.yoco.co.za/terms/privacy-and-app">Terms.</a>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/signup.js